const pricingData = [
    {
        name: 'Starter',
        text: 'Neque quis est',
        icon: 'ti-package',
        package: 19
    },
    {
        name: 'Professional',
        text: 'Quis autem iure',
        icon: 'ti-cup',
        package: 29
    },
    {
        name: 'Enterprise',
        text: 'Sed ut neque unde',
        icon: 'ti-shield',
        package: 39
    },
    {
        name: 'Unlimited',
        text: 'Itaque earum hic',
        icon: 'ti-headphone-alt',
        package: 49
    },
];

export { pricingData }; 
